import { render } from "./FooterComponent.vue?vue&type=template&id=b20de93a"
const script = {}

import exportComponent from "/Users/min_zero/Desktop/haii/projects/alztalk-promotion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__